import { render } from "./Aulas.vue?vue&type=template&id=06c29e6a&scoped=true&ts=true"
import script from "./Aulas.vue?vue&type=script&lang=ts"
export * from "./Aulas.vue?vue&type=script&lang=ts"

import "./Aulas.vue?vue&type=style&index=0&id=06c29e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c29e6a"]])

export default __exports__